import { Button, Flex, Form, Modal, Typography } from "antd"
import { InputOTP } from "antd-input-otp"

import { authStore } from "@src/app/authStore"
import css from "./index.module.css"

type Props = {
  isDisabled: boolean
  isOpen: boolean
  onCancel: () => void
  onChange: (value: string[]) => void
  onSubmit: (value: { otp: string[] }) => void
  value: string[]
}
const { Item } = Form

const { Paragraph, Title } = Typography

export const ModalOtp = ({
  isDisabled,
  isOpen,
  onCancel,
  onChange,
  onSubmit,
  value,
}: Props) => {
  const { merchant } = authStore

  return (
    <Modal
      destroyOnClose
      footer={null}
      getContainer={false}
      onCancel={onCancel}
      open={isOpen}
    >
      <div className={css.modalWrapper}>
        {merchant?.is_otp_enabled ? (
          <>
            <Title level={2}>2FA check</Title>
            <Paragraph style={{ textAlign: "center" }}>
              Enter the verification code from the app Google Authenticator{" "}
            </Paragraph>
            <Form
              className={css.otpForm}
              id="GENERATED_ID_MODALOTP_FORM_VOID_1"
              name="otpForm"
              onFinish={onSubmit}
              size="large"
            >
              <Flex align="center" gap={32} vertical>
                <Item name="otp">
                  <InputOTP
                    autoFocus
                    inputClassName={css.otpInput}
                    inputType="numeric"
                    onChange={onChange}
                    value={value}
                  />
                </Item>
                <Item>
                  <Button
                    disabled={isDisabled}
                    htmlType="submit"
                    id="GENERATED_ID_MODALOTP_BUTTON_SUBMIT_1"
                    size="large"
                    type="primary"
                  >
                    Submit
                  </Button>
                </Item>
              </Flex>
            </Form>
          </>
        ) : (
          <Paragraph style={{ textAlign: "center" }}>
            Please, enable OTP in settings
          </Paragraph>
        )}
      </div>
    </Modal>
  )
}
